export class Client {

    constructor(
        public $key: string,
        public lastName: string,
        public firstName: string,
        public address: string,
        public phoneHouse: string,
        public phoneMobile: string,
        public phoneWork: string,
        public email: string,
        public notifyBySms: boolean,
        public notifyByEmail: boolean,
        public notifyByPush: boolean) {
    }

    static fromJsonList(array): Client[] {
        return array.map(Client.fromJson);
        // même chose: return array.map(json => Lesson.fromJson(json));
    }

    static fromJson({ $key, firstName, lastName, address, phoneHouse, phoneMobile,
        phoneWork, email, notifyBySms, notifyByEmail, notifyByPush }): Client {

        return new Client(
            $key,
            firstName,
            lastName,
            address,
            phoneHouse,
            phoneMobile,
            phoneWork,
            email,
            notifyBySms, 
            notifyByEmail, 
            notifyByPush
        )
    }
}


// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/model/aSupprimer/client.ts